import { useState } from 'react'

export interface useModalReturn {
  isOpen: boolean
  closeModal: () => void
  openModal: () => void
}

export const useModal = (): useModalReturn => {
  const [isOpen, setModalOpen] = useState(false)

  return {
    openModal: () => setModalOpen(true),
    isOpen,
    closeModal: () => setModalOpen(false),
  }
}
